/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../data/addon_status_for_seller';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "GetAllAddonStatusForSellerRequest": {
                "fields": {
                  "installedOnly": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeWebAddons": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetAllAddonStatusForSellerResponse": {
                "fields": {
                  "statusForSeller": {
                    "type": ".squareup.addons.data.AddonStatusForSeller",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonStatusForSellerRequest && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonStatusForSellerResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetAllAddonStatusForSellerRequest @ squareup/addons/external/get_all_addon_status_for_seller.proto at 10:1
 */
export const GetAllAddonStatusForSellerRequest = $root.lookupType('squareup.addons.external.GetAllAddonStatusForSellerRequest');
fixType(GetAllAddonStatusForSellerRequest);
Builder.createAndAttachToType(GetAllAddonStatusForSellerRequest);
/**
 * SOURCE GetAllAddonStatusForSellerResponse @ squareup/addons/external/get_all_addon_status_for_seller.proto at 18:1
 */
export const GetAllAddonStatusForSellerResponse = $root.lookupType('squareup.addons.external.GetAllAddonStatusForSellerResponse');
fixType(GetAllAddonStatusForSellerResponse);
Builder.createAndAttachToType(GetAllAddonStatusForSellerResponse);